import {Component, OnInit} from '@angular/core';
import {TowerService} from "../../api/service/tower.service";
import {CriteresRechercheLogsDto} from "../../api/dto/criteres.recherche.logs.dto";
import {ResultatRechercheLogsDto} from "../../api/dto/resultat.recherche.logs.dto";
import {isNullOrUndefined} from "util";
import {Router} from "@angular/router";
import {NavigationService} from "../../shared/navigation.service";

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html'
})
export class LogsComponent implements OnInit{

  tableauAAfficher: boolean;
  criteres: CriteresRechercheLogsDto;
  resultats: ResultatRechercheLogsDto;
  years: Array<number>;
  months: Array<number>;
  days: Array<number>;
  hours: Array<number>;
  minutes: Array<number>;
  levels: Array<string>;
  environments: Array<string>;
  domains: Array<string>;
  applications: Array<string>;

  constructor(private router: Router,
              private towerService: TowerService,
              private navigationService: NavigationService) {
  }

  ngOnInit(){
    this.tableauAAfficher = false;
    const today = new Date();
    this.criteres = this.navigationService.getCriteres();
    if(isNullOrUndefined(this.criteres)){
      this.criteres = {
        page: 1,
        beginYear: today.getFullYear(),
        beginMonth: today.getMonth() + 1,
        beginDay: today.getDate(),
        beginHour: today.getHours(),
        beginMinute: 0,
        endYear: today.getFullYear(),
        endMonth: today.getMonth() + 1,
        endDay: today.getDate(),
        endHour: today.getHours(),
        endMinute: 59
      };
    }

    this.years = new Array<number>(today.getFullYear() - 2017);
    for (let i = 2018; i <= today.getFullYear(); i++){
      this.years[i-2018] = i;
    }
    this.months = new Array<number>(12);
    for (let i = 1; i <= 12; i++){
      this.months[i-1] = i;
    }
    this.days = new Array<number>(31);
    for (let i = 1; i <= 31; i++){
      this.days[i-1] = i;
    }
    this.hours = new Array<number>(24);
    for (let i = 0; i <= 23; i++){
      this.hours[i] = i;
    }
    this.minutes = new Array<number>(60);
    for (let i = 0; i <= 59; i++){
      this.minutes[i] = i;
    }

    this.domains = ['','activity','nosavions','cms','tower'];
    if(isNullOrUndefined(this.criteres.domain)) {
      this.applications = [''];
    } else {
      const appl = this.criteres.application;
      this.onChangeDomain(this.criteres.domain);
      if(!isNullOrUndefined(appl)){
        this.criteres.application = appl;
      }
    }
    this.levels = ['','FATAL','ERROR','WARN','INFO','DEBUG'];
    this.environments = ['','production','test'];
   // this.cdref.detectChanges();
    this.lancerRecherche();
  }

  onChangeDomain(domain: string) {
    if(domain === 'activity') {
      this.applications = ['','webapp'];
    } else if(domain === 'nosavions') {
      this.applications = ['','web','tactile','admin','widgets','gateway'];
    } else if(domain === 'cms') {
      this.applications = ['','web','admin','contact'];
    } else if(domain === 'tower') {
      this.applications = ['','api'];
    }
    this.criteres.application = '';
  }

  levelStyle(level: string){
    if(level === 'FATAL') {
      return {"background": "#ff3333"};
    } else if(level === 'ERROR'){
      return {"background": "#ff9933"};
    } else if(level === 'WARN'){
      return {"background": "#ffff66"};
    } else if(level === 'INFO'){
      return {"background": "#66ff66"};
    } else if(level === 'DEBUG'){
      return {"background": "#4db8ff"};
    } else {
      return null;
    }
  }

  statusStyle(status: string){
    if(isNullOrUndefined(status)) {
      return null;
    } else if(+status >= 500){
      return {"background": "#ff3333"};
    } else if(+status >= 400) {
      return {"background": "#ff9933"};
    } else {
      return null;
    }
  }

  rechercher() {
    this.criteres.page = 1;
    this.lancerRecherche();
  }

  changerPage(page: number){
    this.criteres = this.navigationService.getCriteres();
    this.criteres.page = page;
    this.lancerRecherche();
  }

  lancerRecherche(){
    this.tableauAAfficher = false;
    this.navigationService.setCriteres(this.criteres);
    this.towerService.rechercherLogs(this.criteres).subscribe(
      resultat => {
        this.resultats = resultat;

        if(!isNullOrUndefined(this.resultats) && !isNullOrUndefined(this.resultats.items)){
          this.tableauAAfficher = true;
        }

      }, error => {
        alert('Erreur durant la recherche');
      }
    );
  }

  selectItem(id: string){
    this.router.navigate(['/logitem', id]);
  }
}



// WEBPACK FOOTER //
// ./src/app/page/logs/logs.component.ts